var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.146,
    height: 16.146,
    viewBox: "0 0 16.146 16.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__open_in_new-24px",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1403",
    d: "M0 0h16.146v16.146H0z",
    "data-name": "Path 1403",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1404",
    d: "M13.764 13.764H4.346V4.346h4.709V3H4.346A1.345 1.345 0 0 0 3 4.346v9.419a1.345 1.345 0 0 0 1.346 1.345h9.419a1.349 1.349 0 0 0 1.346-1.346V9.055h-1.347zM10.4 3v1.346h2.415L6.2 10.959l.949.949 6.613-6.613v2.414h1.348V3z",
    "data-name": "Path 1404",
    transform: "translate(-.982 -.982)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.6f1585c1beea2c4f8c1f4875b206f55f.svg";
export { ForwardRef as ReactComponent };